// Material Dashboard 2 PRO React components
import MDTypography from "components/MDTypography";

function DefaultCell({ value, suffix = "", isLinkText, link, ...other }) {
  return (
    <MDTypography variant="caption" fontWeight="medium" color="text" maxWidth="20px" {...other}>
      {value}
      {suffix && (
        <MDTypography variant="caption" fontWeight="medium" color="secondary">
          &nbsp;&nbsp;{suffix}
        </MDTypography>
      )}
    </MDTypography>
  );
}

export default DefaultCell;
